module.exports = __webpack_public_path__ + "media/landing_page/down-arrow-cashew-21a6eb10.svg";